import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class SsoUsers extends Api {
  constructor() {
    super('sso/users/');
  }

  confirm = data => {
    return this.buildQuery('post', data, 'confirmation');
  };

  getExcel = params => {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/sso/users.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default SsoUsers;
